
import { gql } from '@apollo/client';

export const GET_TAGS = gql`
    query Tags($showPeopleTags: Boolean!, $showCourseTags: Boolean!, $includeAllTags: Boolean) {
    tags(showPeopleTags: $showPeopleTags, showCourseTags: $showCourseTags, includeAllTags: $includeAllTags) {
        id
        name
    }
}`;


export const GET_TAGS_FOR_GROUP = gql`
query TagsForGroup($groupId: Int!) {
    tagsForGroup(groupId: $groupId) {
        id
        name
        code
    }
}`;


export const GET_GROUP_BY_GROUP_ID = (listOfFields: string) => gql`
query TagsForGroup($groupId: Int!) {
    getGroup(groupId: $groupId) {
        ${listOfFields}
    }
}`;
